var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBanCamp3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 164,
    viewBox: "0 0 153 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.716 59.0434L137.019 62.5581C139.02 65.6201 140.935 68.0319 141.55 71.7445C143.375 82.9527 131.264 99.8682 125.004 108.672C124.235 109.736 123.243 111.289 122.702 112.487L116.267 120.317C115.62 121.041 115.071 121.88 114.394 122.597C97.2393 141.037 75.4322 150.526 50.3907 142.698C18.5899 132.771 3.22882 99.6053 12.3871 68.673C16.8066 53.7459 31.1557 33.826 40.7694 21.3086C47.7176 12.2922 56.6835 2.43732 68.9244 9.13865C81.1462 15.841 82.2146 28.4433 76.0227 39.6646C69.1045 52.1796 58.5879 63.7489 52.3825 76.5812C46.5536 88.6107 52.8967 105.679 67.7132 106.336C82.4613 106.989 94.8177 82.8132 102.962 72.5347C109.923 63.7408 120.526 51.2902 132.716 59.0438L132.716 59.0434Z",
    fill: "#F9B634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5048 145.532C16.0077 135.075 -0.0338445 100.165 9.53984 67.8298C11.8697 59.9608 16.7432 50.9683 22.1241 42.4956C27.5337 33.9776 33.5842 25.7887 38.414 19.5001L38.4168 19.4956C41.884 14.9964 46.1652 9.85069 51.3471 6.7761C53.9882 5.20907 56.9429 4.12856 60.2023 3.97916C63.4777 3.82906 66.8694 4.62797 70.3507 6.5338L70.3524 6.53511C77.1841 10.2816 81.0983 15.8293 82.296 22.1544C83.4758 28.3849 81.9642 35.0435 78.6227 41.0993L78.6214 41.101C75.0651 47.5344 70.5909 53.7124 66.363 59.7139C62.0878 65.7826 58.0403 71.7027 55.0561 77.8737L55.0546 77.8764C52.549 83.0477 52.6452 89.3875 55.0004 94.4758C57.3193 99.4853 61.7143 103.098 67.8447 103.37L67.8449 103.369C70.669 103.494 73.5713 102.444 76.6023 100.337C79.6417 98.2245 82.6233 95.1765 85.5189 91.65C88.4048 88.1353 91.1108 84.2638 93.6422 80.5663C96.1341 76.9263 98.5148 73.3663 100.634 70.692C104.085 66.3318 108.755 60.6331 114.273 57.0863C117.071 55.2872 120.228 53.9452 123.678 53.6827C125.931 53.5113 128.217 53.8106 130.508 54.6463L130.707 53.5678L134.595 56.7435L138.898 60.2579L139.254 60.5491L139.505 60.9339C141.335 63.7342 143.736 66.7743 144.48 71.2583L144.481 71.2675C145.565 77.9285 142.53 85.7406 138.93 92.5046C135.244 99.4312 130.538 106.014 127.424 110.392L127.418 110.401L127.411 110.411C126.692 111.406 125.83 112.774 125.407 113.709L125.246 114.068L124.996 114.372L118.561 122.203L118.521 122.252L118.479 122.299C118.241 122.565 118.014 122.859 117.687 123.281C117.391 123.663 117.01 124.149 116.568 124.619L116.568 124.619C98.8803 143.632 75.9437 153.796 49.5048 145.532Z",
    stroke: "white",
    strokeWidth: 5.93911
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_47",
    x: 3.83429,
    y: 0.991476,
    width: 148.293,
    height: 162.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.45433,
    dy: 11.8782
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_47"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_47",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanCamp3);
export default __webpack_public_path__ + "static/media/banCamp3.129a0c720b253e85328e08228efe8454.svg";
export { ForwardRef as ReactComponent };